export const NoteAutocomplete = {
  position: 'relative',
  flow: 'y',
  width: '100%',

  state: {
    autocompleteVisible: false,
    autocompleteSuggestions: [],
    autocompleteIndex: -1,
    autocompleteInputValue: ''
  },

  AutocompleteInput: {
    tag: 'input',
    attr: { type: 'text', autocomplete: 'off' },
    placeholder: '{{ typeToSearch | polyglot }}',
    width: '100%',
    padding: 'Z',
    round: 'Y',
    border: '1px solid inkBorder',
    background: 'ink',
    color: 'inkText',
    fontSize: 'Z',

    onInput: (ev, el, s) => {
      var val = el.node.value
      s.root.update({ autocompleteInputValue: val })
      if (val.length < 2) {
        s.root.update({ autocompleteVisible: false, autocompleteSuggestions: [], autocompleteIndex: -1 })
        return
      }
      var results = el.call('noteAutocomplete', val)
      s.root.update({
        autocompleteVisible: results.length > 0,
        autocompleteSuggestions: results,
        autocompleteIndex: -1
      })
    },

    onKeydown: (ev, el, s) => {
      var suggestions = s.root.autocompleteSuggestions || []
      var idx = s.root.autocompleteIndex !== undefined ? s.root.autocompleteIndex : -1

      if (ev.key === 'ArrowDown') {
        ev.preventDefault()
        var next = idx < suggestions.length - 1 ? idx + 1 : 0
        s.root.update({ autocompleteIndex: next })
      } else if (ev.key === 'ArrowUp') {
        ev.preventDefault()
        var prev = idx > 0 ? idx - 1 : suggestions.length - 1
        s.root.update({ autocompleteIndex: prev })
      } else if (ev.key === 'Enter' && idx >= 0 && suggestions[idx]) {
        ev.preventDefault()
        el.node.value = suggestions[idx].en
        s.root.update({
          autocompleteVisible: false,
          autocompleteSuggestions: [],
          autocompleteIndex: -1,
          autocompleteInputValue: suggestions[idx].en
        })
      } else if (ev.key === 'Escape') {
        s.root.update({ autocompleteVisible: false, autocompleteIndex: -1 })
      }
    },

    onBlur: (ev, el, s) => {
      setTimeout(function () {
        s.root.update({ autocompleteVisible: false, autocompleteIndex: -1 })
      }, 200)
    }
  },

  SuggestionDropdown: {
    show: (el, s) => s.root.autocompleteVisible,
    position: 'absolute',
    top: '100%',
    left: '0',
    width: '100%',
    zIndex: '100',
    marginTop: 'X',
    background: 'inkMid',
    border: '1px solid inkBorder',
    round: 'Y',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',

    children: (el, s) => {
      var suggestions = s.root.autocompleteSuggestions || []
      return suggestions.map(function (item, i) {
        return {
          index: i,
          termEn: item.en,
          termKa: item.ka,
          termCategory: item.category
        }
      })
    },
    childrenAs: 'state',
    childExtends: 'NoteAutocompleteSuggestion'
  }
}

export const NoteAutocompleteSuggestion = {
  flow: 'x',
  align: 'center space-between',
  padding: 'Y Z',
  cursor: 'pointer',
  background: (el, s) => {
    var idx = s.root.autocompleteIndex
    return s.index === idx ? 'teal.15' : 'transparent'
  },
  transition: 'background 0.1s',
  ':hover': { background: 'teal.15' },

  TermInfo: {
    flow: 'y',
    gap: 'X',
    TermEn: {
      text: (el, s) => s.termEn || '',
      fontSize: 'Z',
      fontWeight: '600',
      color: 'inkText'
    },
    TermKa: {
      text: (el, s) => s.termKa || '',
      fontSize: 'Y',
      color: 'inkMuted'
    }
  },

  CategoryBadge: {
    tag: 'span',
    text: (el, s) => s.termCategory || '',
    fontSize: 'X',
    fontWeight: '600',
    padding: 'X Y',
    round: 'X',
    textTransform: 'uppercase',
    background: (el, s) => {
      var cat = s.termCategory
      if (cat === 'procedure') return 'teal.15'
      if (cat === 'finding') return 'amber.15'
      if (cat === 'material') return 'blue.15'
      if (cat === 'medication') return 'purple.15'
      return 'inkSurface'
    },
    color: (el, s) => {
      var cat = s.termCategory
      if (cat === 'procedure') return 'teal'
      if (cat === 'finding') return 'amber'
      if (cat === 'material') return 'blue'
      if (cat === 'medication') return 'purple'
      return 'inkMuted'
    }
  },

  onClick: (el, s) => {
    s.root.update({
      autocompleteVisible: false,
      autocompleteSuggestions: [],
      autocompleteIndex: -1,
      autocompleteInputValue: s.termEn
    })
    // Find the input and set its value
    var root = el.parent.parent
    if (root && root.AutocompleteInput && root.AutocompleteInput.node) {
      root.AutocompleteInput.node.value = s.termEn
    }
  }
}
